import type { Metric } from "web-vitals";

function reportHandler(metric: Metric) {
  console.debug(metric);
}

export default reportHandler;
